import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UsersService } from '../services/users.service';
import { User } from '../models/user.model';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)
  const router = inject(Router);
  const usersService = inject(UsersService)

  if(!authService.isAuthenticated) {
    router.navigate(['login']);
    return authService.isAuthenticated;
  } else {
    usersService.getUserByToken()
    .subscribe({
      next: (res:any) => {
        authService.setUser(<User>res.user);
      },
      error: err => {
        console.log("error", err);
        if (err.status === 401) {
          authService.clearAuthData();
          router.navigate(['login']);
        }

      }
      
    })
    // console.log("Poszło: ", authService.isAuthenticated);
    
    return authService.isAuthenticated;
  }
};
